"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Modal_1 = __importDefault(require("./Modal"));
var react_1 = __importDefault(require("react"));
var AnimateMounted_1 = require("./AnimateMounted");
var AnimatedModal = /** @class */ (function (_super) {
    __extends(AnimatedModal, _super);
    function AnimatedModal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AnimatedModal.prototype.render = function () {
        var _this = this;
        var modalHTML = null;
        if (this.props.showSizeChart) {
            var duration_1 = 100;
            modalHTML =
                react_1.default.createElement(AnimateMounted_1.AnimateMounted, { duration: duration_1 }, function (state) {
                    var defaultStyle = {
                        transition: "opacity " + duration_1 + "ms ease-in",
                        opacity: 0,
                    };
                    var transitionStyles = {
                        entering: { opacity: 0 },
                        entered: { opacity: 1 },
                    };
                    var style = __assign({}, defaultStyle, transitionStyles[state], { position: "fixed", zIndex: _this.props.zIndex });
                    return react_1.default.createElement("div", { style: style },
                        react_1.default.createElement(Modal_1.default, __assign({}, _this.props)));
                });
        }
        return react_1.default.createElement("div", null, modalHTML);
    };
    return AnimatedModal;
}(react_1.default.PureComponent));
exports.default = AnimatedModal;
